import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=2e3b45bb&scoped=true"
import script from "./Incident.vue?vue&type=script&lang=js"
export * from "./Incident.vue?vue&type=script&lang=js"
import style0 from "./Incident.vue?vue&type=style&index=0&id=2e3b45bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b45bb",
  null
  
)

export default component.exports